import { changeMobileService } from '@afterpaytouch/portal-api/consumer/account/change-mobile'

export const {
  useChangeMobileVerifyEmailMutation,
  useChangeMobileReverifyEmailMutation,
  useChangeMobileCheckEmailMutation,
  useChangeMobileVerifyMobileMutation,
  useChangeMobileCheckMobileMutation,
} = changeMobileService
